<template>
  <div class="container-md">
    <div class="row h-100">
      <div class="col-12 col-md-9 min-vh-86 " style="background-color: #f2f2f2;">
        <div v-for="(item,index) in docs" :key="index" :item="item" class="rounded ps-2 pe-2 mt-1 pt-3 pb-3 itemCategory">
              <div class ="me-1 itemCategory__name">
                  <span class="fw-bold fs-5 " style="display: flex; justify-content: center; align-items: center">{{ item.catName }}</span>
              </div>
              <div class ="itemCategory__func">
                <div class ="itemCategory__func__btn me-1 rounded" @click.prevent="EditItemCategory(item)">
                  <img :src="imageUrls.iconThayDoi">
              </div>
                <div class="itemCategory__func__btn rounded" @click.prevent="DelteItemCategory(item)">  
                  <img :src="imageUrls.iconDele">
                </div>
              

              </div>
          </div>
      </div>
      <div class="col-12 col-md-3" style="background-color:#f8f9fa;"> 
        <CreateCategory/>
      </div>
    </div>
  </div>
   <div v-show = "fromEdit" class ="from-Edit p-0">
      <EditCategory :item="selectedItem"></EditCategory>
   </div>
   <div v-show = "fromDelete" class ="from-Edit p-0">
      <DeleteCategory :item="selectedItem"></DeleteCategory>
   </div>
  
</template>
  
  <script>

  import {postReceiveListCategory} from "@/components/js/VposService";
  import CreateCategory from './CreateCategory.vue';
  import EditCategory from './EditCategory.vue';
  import DeleteCategory from "./DeleteCategory.vue";
  import { imageUrls } from "@/components/js/urlImg";

    export default {
    
      components:{
        CreateCategory, EditCategory, DeleteCategory
      },
      data() {
        return {  
          offset: 0, limit: 100, InputIdStore: "", docs: [], fromEdit: false, fromDelete: false, selectedItem: null, imageUrls: imageUrls,
        };
    },
    mounted(){
      // Add event listener for window clicks
    window.addEventListener('click', this.handleWindowClick);
      this.ReceiveListCategory();
    },
    beforeUnmount(){
    // Remove event listener when component is about to be unmounted
      window.removeEventListener('click', this.handleWindowClick);
    },

    methods:{
        EditItemCategory(item){
          this.selectedItem = item;
          localStorage.setItem("categoryName", item.catName);
          // console.log("edit item categoty:" + JSON.stringify(this.selectedItem));
          this.fromEdit = true;
          this.fromDelete = false;
         
        },
      
        DelteItemCategory(item){
          // alert("delete item categoty:" + item.idStore +"___trangThai: " +item.trangThai);
          this.selectedItem = item;
          // console.log("edit item categoty:" + JSON.stringify(this.selectedItem));
          this.fromEdit = false;
          this.fromDelete = true;
        },
        async ReceiveListCategory(){
        try{
            this.InputIdStore = localStorage.getItem('idCuaHang');
            console.log("InputIdStore ========> " + this.InputIdStore);
            const response = await postReceiveListCategory(this.InputIdStore, this.offset, this.limit);
            console.log("response ========>"+ JSON.stringify(response.result.docs));
            this.docs = response.result.docs
            }catch(e){
                console.log("Exception e:",e);
            }
        },
        handleWindowClick(event) {
          if (this.fromEdit && event.target.className ==="hideFromEdit posEdit-1__1") {
                    this.fromEdit = false;
                    localStorage.removeItem("categoryName");
                   
              }

          if (this.fromDelete && event.target.className ==="hideFromEdit posDel-1__1") {
                this.fromDelete = false;
          }
            }, 
            
        }
  }
  </script>
  <style scoped>
  .itemCategory{
    display: flex; background-color: white; height: auto; max-height: auto
  }
  .itemCategory__name{
    flex-grow: 5; justify-content: flex-start; display: flex; width: 700px;
  }
  .itemCategory__func{
    display: flex; flex-wrap: nowrap;flex-grow: 1;
  }
  .itemCategory__func__btn{
    width: 15px; flex-grow: 1; display: flex; justify-content: center; align-items: center; color: white; cursor: pointer;
  }

  .from-Edit{
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .min-vh-86{
    min-height: 86vh;
    height: auto;
  }
  </style>